export default {
   saffronUser : {
      getCurrentUserUrl : 'user/current',
      getRefreshTokenUrl : 'token/refresh',
      getJwtBaseUrl : 'token/jwt',
   },
   guestLoginRedirect: {name: 'login'},
   loginRedirect: {name: 'index'}
}
